import Grid from '@/global/components/ui/Grid'
import { SCOPES_CONHECIDOS, Scope } from '@acme/core'
import {
    CardCheckboxForm,
    FormField,
    FormFieldSwitchSelect,
} from 'global/components/Form'
import React from 'react'

export const SCOPE_DESCRIPTIONS: Record<
    Scope,
    { label: string; description: string }
> = {
    'registros:read': {
        label: 'Registros de ponto',
        description: 'Consulta marcações e batidas de ponto dos funcionários.',
    },
    'funcionarios:read': {
        label: 'Funcionários',
        description:
            'Consulta dados cadastrais de funcionários e vínculos de locais.',
    },
    'calculo:read': {
        label: 'Cálculo e espelho',
        description: 'Consulta apuração do cálculo e espelho de ponto.',
    },
    'saldo-horas:read': {
        label: 'Saldo de horas',
        description: 'Consulta saldo de horas e extrato de banco de horas.',
    },
    'afastamentos:read': {
        label: 'Afastamentos',
        description:
            'Consulta afastamentos, folgas e atestados em dias, com motivo, justificativa e anexo. Contém dado de saúde.',
    },
    'abonos:read': {
        label: 'Abonos',
        description:
            'Consulta abonos de horas, com descrição, justificativa e anexo, inclusive os de saúde ocupacional. Contém dado de saúde.',
    },
}

const OPCOES_ESCOPO = SCOPES_CONHECIDOS.map((scope: Scope) => ({
    value: scope,
    titulo: SCOPE_DESCRIPTIONS[scope].label,
    descricao: SCOPE_DESCRIPTIONS[scope].description,
}))

/** `ativo` chega booleano: o `Dialog.Root` converte o `'S'`/`'N'` da API. */
const OPCOES_STATUS = [
    { value: true, label: 'Ativo' },
    { value: false, label: 'Inativo' },
] as const

interface CredencialFormProps {
    isEditing?: boolean
    /**
     * Mostra o campo de cota (RPM). A cota é decisão comercial da Farol, não do
     * cliente — só Administrador e Suporte editam, pela tela por linha em
     * Administração. A API descarta o campo de quem não tem alçada, então
     * exibi-lo aqui faria o cliente preencher algo sem efeito.
     */
    podeEditarCota?: boolean
}

export const CredencialForm: React.FC<CredencialFormProps> = ({
    isEditing = false,
    podeEditarCota = false,
}) => (
    <Grid container spacing={2}>
        <Grid item xs={12}>
            <FormField
                name="nome"
                label="Nome da aplicação / integração"
                placeholder="Ex: PowerBI Diretoria, ERP Senior, Totvs"
                required
            />
        </Grid>

        {podeEditarCota && (
            <Grid item xs={12} sm={6}>
                <FormField
                    name="rateLimitRpm"
                    label="Limite de requisições por minuto (RPM)"
                    type="number"
                    defaultValue={60}
                    required
                />
            </Grid>
        )}

        {isEditing && (
            <Grid item xs={12} sm={6}>
                <FormFieldSwitchSelect
                    name="ativo"
                    label="Status"
                    options={OPCOES_STATUS}
                />
            </Grid>
        )}

        <Grid item xs={12}>
            <div className="h-4" />
        </Grid>

        <Grid item xs={12}>
            <CardCheckboxForm
                name="scopes"
                label="Escopos de acesso permitidos"
                required
                colunas={1}
                options={OPCOES_ESCOPO}
            />
        </Grid>
    </Grid>
)
